import React, { useEffect } from "react";
import {
  MsalAuthenticationTemplate,
  type MsalAuthenticationResult,
  useMsal,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "authConfig";

const AuthErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
  const { instance } = useMsal();

  useEffect(() => {
    const message = (error as any)?.errorMessage || (error as any)?.message || "";

    if (message.includes("AADSTS90009") || message.includes("invalid_request")) {
      instance.loginRedirect(loginRequest);
      return;
    }

    instance.loginRedirect(loginRequest);
  }, [error, instance]);

  return null;
};

export const withAuthentication = <P extends object>(
  WrappedComponent: React.ComponentType<P>
): React.FC<P> => {
  return (props: P) => (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={AuthErrorComponent}
    >
      <WrappedComponent {...props} />
    </MsalAuthenticationTemplate>
  );
};
